import { Box, Button, Card, CardFooter, Flex, Grid, GridItem, Icon, Image, Spinner } from '@chakra-ui/react';
import React, { useCallback, useEffect, useMemo } from 'react';
import moment from 'moment';
import { FaUser } from 'react-icons/fa6';

import { Activity } from '@app/api/socket-service';
import { useApi } from '@app/hooks';
import { DateRangeField, Paper, TextField, Txt } from '@app/components/common';
import { USER_DATE_FORMAT } from '@app/utils';
import { TablePagination } from '@app/components/common/table/components/table-pagination';
import { DateRange } from '@app/components/common/date-range-picker/types';

import { ThumbnailCombine } from './thumbnail-combine';

export const ActivitiesGallery = () => {
    const api = useApi();
    const [activities, setActivities] = React.useState<Activity[]>([]);
    const [filter, setFilter] = React.useState<Record<string, string | undefined | string[] | number[]>>({});
    const [page, setPage] = React.useState(1);
    const [total, setTotal] = React.useState(0);
    const [loading, setLoading] = React.useState(false);

    const fetchActivities = useCallback(async (page: number, filter: Record<string, string | undefined | string[] | number[]>) => {
      setLoading(true);
      const activities = await api.socket.getActivities({
          filter,
          sort: 'id+',
          limit: 20,
          offset: (page - 1) * 20
      });
      setActivities(activities.data.data);
      setTotal(activities.data.total);
      setLoading(false);
    }, []);

    // useEffect(() => {
    //     fetchActivities(1, {});
    // }, []);

    const setPeriod = useCallback((value: DateRange) => {
      const period = value ? [
        value.startDate.unix() * 1000000,
        value.endDate.unix() * 1000000
      ] : undefined;
      setFilter({ period });
      fetchActivities(1, { period });
    }, [fetchActivities]);

    return <>
      <Paper>
        <Flex gap={2} px={3} py={2}>
          <DateRangeField
            id='period'
            label="Период"
            value={useMemo(() => filter.period ? { startDate: moment(filter.period[0]), endDate: moment(filter.period[1]) } : undefined, [filter.period])}
            onChange={setPeriod}
          />
          <TextField
            id='entityId'
            label="ID сущности"
            value={filter.entityid as string}
            onChange={(value) => {
              setFilter({ ...filter, entityid: value });
              fetchActivities(1, { ...filter, entityid: value });
            }}
          />
          <TextField
            id='username'
            label="Имя пользователя"
            value={filter.username as string}
            onChange={(value) => {
              setFilter({ ...filter, username: value });
              fetchActivities(1, { ...filter, username: value });
            }}
          />  
        </Flex>
      </Paper>
      <Grid gap={4} templateColumns='repeat(auto-fill, minmax(128px, 1fr))' mb={4} mt={4}>
        {loading && <Box 
          w='100%' h='100%'  
          position='absolute' 
          display='flex' 
          justifyContent='center' 
          alignItems='center'
          backgroundColor='whiteAlpha.500'
          zIndex={1}
        ><Spinner/></Box>}
        {activities.map((activity) => {
          return <GridItem key={activity.id} height="100%">
              <Card >
                {activity.thumbnails?.[0] && 
                <ThumbnailCombine thumbnails={activity.thumbnails} />}
                {!activity.thumbnails?.[0] && <Image
                  objectFit='cover'
                  src="/images/empty.png"
                  minH={128}
                  alt='Chakra UI'
                />}
                <CardFooter
                  justify='space-between'
                  flexWrap='wrap'
                  sx={{
                    '& > button': {
                        minW: '136px',
                    },
                    }}
                >
                  <Flex flexDirection='column'>
                    <Txt fontSize={12}>{moment(activity.timestamp / 1000).format(USER_DATE_FORMAT)}</Txt>
                    <Flex gap={2} alignItems='center'>
                      <FaUser fill="gray" size={12}/>
                      <Txt size='xxs' textColor='gray.500'>{activity.username.split('-')[0]}</Txt>
                    </Flex>
                  </Flex>
                </CardFooter>
              </Card>
            </GridItem>;
        })}  
      </Grid>
      <Paper>
        <TablePagination 
          page={page} pageSize={20} 
          total={total} 
          onPageChange={(page) => {
            setPage(page);
            fetchActivities(page, filter);
          }} 
          onPageSizeChange={() => {}}          
        />
      </Paper>
      
    </>;
};